<!--资产列表-->
<template>
  <div class="assetList">
    <div class="wrapper">
      <div class="vant-table">
        <van-radio-group v-model="pageConfig.checkedRow">
          <table cellspacing="0" class="table">
            <tr>
              <th class="th" width="20"></th>
              <th class="th" width="100">资产代码</th>
              <th class="th" width="100">资产名称</th>
              <th class="th" width="100">资产分类</th>
              <th class="th" width="200">保管部门</th>
              <th class="th" width="100">保管人</th>
              <th class="th" width="120">规格</th>
              <th class="th" width="120">位置</th>
              <th class="th" width="120">所属公司</th>
            </tr>
            <tr v-for="(item, index) in pageConfig.assetList" :key="index">
              <td align="center">
                <van-radio :name="item"></van-radio>
              </td>
              <td>
                {{ item.asset_code }}
              </td>
              <td>
                {{ item.asset_name }}
              </td>
              <td>
                {{ item.asset_type_name }}
              </td>
              <td>
                {{ item.custodian_dept_name }}
              </td>
              <td>
                {{ item.custodian_emp_name }}
              </td>
              <td>
                {{ item.specs }}
              </td>
              <td>
                {{ item.asset_location }}
              </td>
              <td>
                {{ item.company_name }}
              </td>
            </tr>
          </table>
        </van-radio-group>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="page-botton">
        <van-button
          type="primary"
          size="normal"
          @click="methods.saveAssetSelect()"
          >确定</van-button
        >
        <van-button
          size="normal"
          @click="methods.onclose()"
          plain
          hairline
          type="primary"
          >取消</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, ref, onMounted } from 'vue'
import { CallIPassService } from '@/api/oawfs.js'
import { Toast, Dialog } from 'vant'

export default {
  props: ['apply_emp_id', 'row_id','company_id'],
  setup(props, { emit }) {
    //页面参数
    const pageConfig = reactive({
      assetList: [],
      checkedRow: null,
    })
    //内置函数
    const methods = {
      init: function () {
        //获取资产列表
        methods.getAssetList()
      },
      //获取资产列表
      getAssetList: function () {
        let param = {
          management_type_code: '1', //列账
          asset_status: '00,04', //资产状态，00使用中/04闲置
          emp_id: props.apply_emp_id, //申请人id
          company_id: props.company_id, //公司id
        }
        pageConfig.assetList = []
        CallIPassService('eam1000', param).then((res) => {
          if (res.code == 200) {
            if (res.data) {
              let data = JSON.parse(res.data)
              pageConfig.assetList = data
            }
          }
        })
      },
      //保存资产选择
      saveAssetSelect: function () {
        if (!pageConfig.checkedRow || pageConfig.checkedRow.length == 0) {
          Toast('请选择资产信息')
          return
        }
        emit('onclose', pageConfig.checkedRow)
      },
      onclose: function () {
        emit('onclose', null)
      }
    }
    onMounted(() => {
      methods.init()
    })
    return {
      pageConfig,
      methods,
    }
  },
}
</script>
<style scoped lang="scss">
.assetList {
  .wrapper {
    overflow: auto;
    width: 100%;
    height: 80vh;
    background-color: #fff;
    .vant-table {
      padding: 10px 0;
      width: 1550px;
      height: calc(100vh - 80px);

      table {
        width: 100%;
        padding: 5px;

        tr {
          line-height: 30px;
        }

        .th {
          height: 30px;
          line-height: 30px;
          background-color: #f5f6f6;
          text-align: center;
        }

        td {
          height: 30px;
          text-align: center;
          border-bottom: 1px solid #f5f6f6;
        }

        .link-text {
          color: #0089ff;
        }
      }

      .van-button {
        margin: 0 10px;
      }
    }
  }

  .footer-bottom {
    padding: 0px 10px;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .page-botton {
      width: 100%;
      .van-button {
        float: right;
        margin-left: 5px;
      }
    }
  }
}
</style>
